import React from "react";
import { Box, Container, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const principles = [
  {
    title: "Balance & Accountability",
    description:
      "One-party rule leads to complacency. Middletown deserves a representative who listens, asks tough questions, and demands accountability.",
  },
  {
    title: "Common-Sense Over Ideology",
    description:
      'I’ll evaluate every bill on its merits: "Does this make sense for Middletown?" That’s the only test.',
  },
  {
    title: "Fiscal Responsibility and Transparency",
    description:
      "Government should live within its means, just like families do. Every dollar must be spent wisely.",
  },
  {
    title: "Individual Freedom",
    description:
      "Parents should have a voice in their children's education. Business owners should operate free from excessive regulation.",
  },
];

const PrinciplesSection = () => {
  return (
    <Box
      className="principles-section-root"
      sx={{
        backgroundColor: "#0A192F", // Deep Navy
        py: { xs: 10, md: 15 },
        // minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg" className="principles-container">
        {/* TOP CONTENT HEADER */}
        <Box
          className="header-content"
          sx={{
            textAlign: "center",
            maxWidth: "800px",
            mx: "auto",
            mb: 8,
          }}
        >
          <Typography
            className="overline-text"
            sx={{
              color: "#C59324",
              fontWeight: 700,
              letterSpacing: "0.2em",
              fontSize: "0.85rem",
              textTransform: "uppercase",
              mb: 2,
            }}
          >
            Why Now
          </Typography>

          <Typography
            className="headline-main"
            sx={{
              fontFamily: "'Playfair Display', serif",
              color: "#fff",
              fontWeight: 600,
              lineHeight: 1.2,
              mb: 3,
              fontSize: { xs: "2.2rem", md: "3.5rem" },
            }}
          >
            It's About{" "}
            <Box
              component="span"
              sx={{
                color: "#C59324",
                fontStyle: "italic",
                fontWeight: 500,
              }}
            >
              Principles
            </Box>
            , Not Politics
          </Typography>

          <Typography
            className="header-subtext"
            sx={{
              color: "#B8C0D1",
              fontSize: "1.1rem",
              lineHeight: 1.8,
              maxWidth: "700px",
              mx: "auto",
            }}
          >
            Delaware has been under one-party control for nearly 40 years.
            Democrats are one seat away from a constitutional supermajority. I
            am running because Delaware needs balance, not domination.
          </Typography>
        </Box>

        {/* PRINCIPLES CARDS - Flexbox Implementation */}
        <Box
          className="cards-flex-wrapper"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 3,
            justifyContent: "center",
          }}
        >
          {principles.map((item, index) => (
            <Box
              key={index}
              className={`principle-card-${index}`}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.08)",
                borderRadius: "8px",
                p: 4,
                width: { xs: "100%", md: "calc(50% - 12px)" }, // Half width minus gap
                boxSizing: "border-box",
                display: "flex",
                gap: 2,
              }}
            >
              <CheckIcon
                sx={{
                  color: "#C59324",
                  fontSize: "1.2rem",
                  mt: "4px",
                }}
              />
              <Box>
                <Typography
                  className="card-title"
                  sx={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    mb: 1.5,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  className="card-desc"
                  sx={{
                    color: "#B8C0D1",
                    fontSize: "0.95rem",
                    lineHeight: 1.7,
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* FOOTER QUOTE */}
        <Box
          className="quote-footer-wrapper"
          sx={{
            textAlign: "center",
            mt: 10,
            maxWidth: "900px",
            mx: "auto",
          }}
        >
          <Typography
            className="final-quote"
            sx={{
              color: "#E5D7C3", // Warm cream/gold
              fontSize: { xs: "1.4rem", md: "2.2rem" },
              fontStyle: "italic",
              lineHeight: 1.5,
              fontFamily: "'Playfair Display', serif",
              opacity: 0.9,
            }}
          >
            "I will vote on the merits of every issue. My only loyalty is to the
            people of Middletown and to common sense."
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrinciplesSection;
